/**
 * StatLeadersFormSection - Stat leaders toggle for events
 * Extracted from EventsTab.jsx
 */
import { BarChart3 } from "lucide-react";

export const StatLeadersFormSection = ({ formData, setFormData }) => (
  <div className="border-t border-white/10 pt-6">
    <div className="flex items-center justify-between mb-4">
      <div className="flex items-center gap-3">
        <BarChart3 className="w-5 h-5 text-green-500" />
        <div>
          <h4 className="font-secondary text-sm font-bold uppercase text-white">Stat Leaders</h4>
          <p className="text-[10px] text-zinc-500">Show top players in Points, Rebounds, and Assists on event page</p>
        </div>
      </div>
      <label className="flex items-center gap-2 cursor-pointer">
        <input 
          type="checkbox" 
          checked={formData.stat_leaders_enabled}
          onChange={(e) => setFormData({...formData, stat_leaders_enabled: e.target.checked})}
          className="w-4 h-4"
          data-testid="stat-leaders-toggle"
        />
        <span className="text-xs text-zinc-400">Enable</span>
      </label>
    </div>

    {formData.stat_leaders_enabled && (
      <div className="p-4 bg-green-500/5 border border-green-500/20">
        <p className="text-xs text-zinc-400">
          <strong>Note:</strong> Stat leaders are automatically pulled from games that have a 
          <span className="text-green-400"> Stats Link</span> attached in the bracket editor. 
          Make sure your bracket games have valid StatMoose or PrestoSports links.
        </p>
      </div>
    )}
  </div>
);

export default StatLeadersFormSection;
